:host {
  --nav-item-gap: var(--nav-navgap, 40px);
  --nav-active-color: var(--nav-active, #FD5000);
  --nav-svg-size: var(--nav-size, 16px);
  display: block;
}

.jackery-tabs {
  display: flex;
  flex-direction: column;
}

/* tab type */
:host(.type--fill) .nav-container {
  background: var(--tabbg);
  border-radius: calc(var(--nav-height) / 2);
  /* margin: unset; */
}
:host(.type--fill) .jackery-tab-line {
  height: 100%;
  background-color: var(--activebg);
  border-radius: calc(var(--nav-height) / 2);
}
:host(.type--fill) jackery-tab-nav {
  padding: 0 var(--nav-height);
  position: relative;
  z-index: 2;
}
:host(.type--fill) .jackery-tab-nav-con {
  border: none;
}
/* tab type */

/* nav-align */
:host(.align--left) .jackery-tab-nav-con {
 margin-left: 0;
}

:host(.align--right) .jackery-tab-nav-con {
  margin-right: 0;
 }
/* nav-align */


/* tab position */
:host(.position--left) jackery-tab-nav, :host(.position--right) jackery-tab-nav {
  --tab-item-font-size: calc(var(--nav-svg-size) - 2px);
  width: 100%;
}
:host(.position--left) ::slotted(jackery-tab-content), :host(.position--right) ::slotted(jackery-tab-content) {
  max-height: var(--maxheight);
}
:host(.position--left) .jackery-tabs {
  flex-direction: row;
}
:host(.position--right) .jackery-tabs {
  flex-direction: row-reverse;
}
:host(.position--left) .jackery-tab-nav, :host(.position--right) .jackery-tab-nav {
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  padding: 0 8px;
  max-height: var(--maxheight);
  overflow-y: auto;
}
:host(.position--left) .jackery-tab-nav::-webkit-scrollbar, :host(.position--right) .jackery-tab-nav::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}
:host(.position--left) .jackery-tab-line {
  width: 2px;
  left: unset;
  right: 0;
  bottom: unset;
  top: 0;
}
:host(.position--right) .jackery-tab-line {
  width: 2px;
  left: 0;
  right: unset;
  bottom: unset;
  top: 0;
}

:host(.position--left) .jackery-tab-nav-con {
  border-bottom: none;
  border-right: 1px solid #DDDDDD;
}
:host(.position--right) .jackery-tab-nav-con {
  border-bottom: none;
  border-left: 1px solid #DDDDDD;
}
/* tab position */

/* hideline */
:host(.hideline) .jackery-tab-nav {
  border-bottom: none;
}
/* hideline */

/* sticky */
:host(.sticky) .nav-container {
  position: sticky;
  z-index: 999;
  top: var(--areatop);
}
/* sticky */

.nav-container {
  display: flex;
  position: relative;
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
}

/* Tabs Nav */
.jackery-tab-nav {
  user-select: none;
  position: relative;
  display: flex;
  gap: var(--nav-item-gap);
  margin: 0 auto;
  justify-content: space-between;
}

/* tabaround */
:host(.tabaround) .jackery-tab-nav {
  width: 100%;
  justify-content: space-around;
}
/* tabaround */

.jackery-tab-line {
  position: absolute;
  display: block;
  bottom: 0;
  left: 0;
  height: 2px;
  z-index: 1;
  background-color: var(--nav-active-color);
  transition: all .24s ease-in-out;
}


.jackery-tab-nav-con {
  display: flex;
  flex: 1;
  position: relative;
  border-bottom: 1px solid #DDDDDD;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
}
.jackery-tab-nav-con::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

.jackery-tab-content {
  overflow: hidden;
  flex: 1;
}
.jackery-tab-content-wrap {
  display: flex;
  width: 100%;
  height: 100%;
  transition-property: transform;
  transition-duration: 0.25s;
  transition-timing-function: ease-in-out;
}
::slotted(jackery-tab-content) {
  box-sizing: border-box;
  width: 100%;
  visibility: visible;
  height: 100%;
  flex-shrink: 0;
  overflow: auto;
}

::slotted(jackery-tab-content:not(.active)) {
  visibility: hidden;
  height: 0;
}
::selection {
  background: transparent;
}

.jackery-tabs-nav-operations {
  position: relative;
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: center;
  width: 40px;
  cursor: pointer;
}
.jackery-tabs-nav-operations::before {
  content: '';
  opacity: 1;
  position: absolute;
  z-index: 2;
  pointer-events: none;
  left: -32px;
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);
  top: 0;
  bottom: 0;
  width: 32px;
}
.jackery-tabs-nav-operations.jackery-tabs-nav-operations--prev::before {
  left: 4px;
  transform: scaleY(180deg);
}
.jackery-tabs-nav-operations svg {
  width: var(--nav-svg-size);
  height: var(--nav-svg-size);
}
.jackery-tabs-nav-operations--prev svg{
  transform: rotate(180deg);
}
.jackery-tabs-nav-operations:hover svg path,
.jackery-tabs-nav-operations:active svg path {
  transition: all .24s;
  fill: #333;
}
/* Tabs Nav */

@media screen and (max-width: 1024px) {
  :host {
    --nav-height-m: calc(var(--nav-height) - 4px);
    --nav-size-m: 14px;
    --nav-item-gap: 24px;


    --nav-active-color: var(--nav-active, #FD5000);
    --nav-svg-size: var(--nav-size, 16px);
    display: block;
  }
  .jackery-tabs-nav-operations {
    height: 44px;
    width: 40px;
  }
}